import { request } from "../utils/request.js"

export const customizePayOrder_exportForManage = (pojo, args) => request({
    url: 'customizePayOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePayOrder_findPageForManage = (pojo, args) => request({
    url: 'customizePayOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePayOrder_findPageListForManage = (pojo, args) => request({
    url: 'customizePayOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePayOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'customizePayOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePayOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'customizePayOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePayOrder_saveIntoDraft = (pojo, args) => request({
    url: 'customizePayOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePayOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'customizePayOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePayOrder_update = (pojo, args) => request({
    url: 'customizePayOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePayOrder_updateAndSubmit = (pojo, args) => request({
    url: 'customizePayOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePayOrder_submitById = (id, args) => request({
    url: 'customizePayOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePayOrder_deleteById = (id, args) => request({
    url: 'customizePayOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePayOrder_approval = (pojo, args) => request({
    url: 'customizePayOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePayOrder_findById = (id, args) => request({
    url: 'customizePayOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizePayOrder_findVoById = (id, args) => request({
    url: 'customizePayOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})




// WEBPACK FOOTER //
// ./src/api/customizePayOrder.js